export default __webpack_public_path__ + "static/media/privilege-ticket.1901ace5.svg";